import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IServicingProviderDTO, IServicingProviderResponseDTO } from '../model';
import { PhysicianAccountPgpDTO, PhysicianAccountPgpsDTO } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationProviderService {
  dmeposProvider = new BehaviorSubject<IServicingProviderDTO>(null);
  orderingProvider = new BehaviorSubject<PhysicianAccountPgpsDTO>(null);

  setDMEPOSProvider(dmeProvider: IServicingProviderResponseDTO = null) {
    let dmeposProvider: IServicingProviderDTO = null;

    if (dmeProvider) {
      dmeposProvider = this.initializeDMEPOSProvider();
      dmeposProvider.providerAccountDTO = dmeProvider.providerAccountDTO;
      dmeposProvider.providerPgpDTOList[0] = dmeProvider.providerPgpDTO;
    }

    this.dmeposProvider.next(dmeposProvider);
  }

  setOrderingProvider(orderingProvider: PhysicianAccountPgpDTO) {
    let orderingProviderPgpsDTO: PhysicianAccountPgpsDTO = null;

    if (orderingProvider) {
      orderingProviderPgpsDTO = this.initializeOrderingProvider();
      orderingProviderPgpsDTO.physicianAccountDTO = orderingProvider.physicianAccountDTO;
      orderingProviderPgpsDTO.physicianPgpDTOList[0] = orderingProvider.physicianPgpDTO;
    }

    this.orderingProvider.next(orderingProviderPgpsDTO);
  }

  private initializeDMEPOSProvider(): IServicingProviderDTO {
    return {
      providerAccountDTO: {},
      providerPgpDTOList: []
    }
  }

  private initializeOrderingProvider() {
    return {
      physicianAccountDTO: {
        physicianAccountId: '',
        recordType: '',
        accountId: '',
        accountName: '',
        practiceTaxId: '',
        practiceNpinumber: '',
        cmsnumber: '',
        sanctionCheckDate: null,
        sanctionsCheck: null,
        sanctionBeginDate: null,
        physicalStreet: '',
        physicalState: '',
        physicalCity: '',
        physicalZip: '',
        physicalCounty: '',
        physicalAddressVerificationDate: null,
        physicalAddressVerified: null,
        remitAddressVerified: null,
        remitAddressVerifiedDate: null,
        phone: '',
        fax: '',
        dataSource: '',
        sourceLastModifiedBy: '',
        sourceLastModifiedDate: '',
        etlChecksum: 0,
        etlCreatedBy: '',
        etlInsertDate: '',
        etlModifiedBy: '',
        etlModifiedDate: '',
        outOfMembersNetwork: false
      },
      physicianPgpDTOList: []
    }
  }
}
